import ChatApp from "../components/chat";

export default function ChatPage() {
  return <ChatApp />;
}
